<template>
  <v-card class="project-team-card">
    <v-card-title>
      {{ title }}
      <div class="project-team-card__details">
        {{ usersCount }} {{ usersCountSuffix }}
      </div>
    </v-card-title>

    <v-card-text class="project-team-card__content">
      <template v-if="usersCount">
        <app-user
          v-for="user in users"
          :key="user.id"
          :user="user"
          actions
        >
          <template
            v-if="editable"
            #menu
          >
            <v-menu
              bottom
              left
              offset-y
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  class="mr-n2"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>

              <v-list
                dense
                min-width="160"
              >
                <v-list-item
                  dense
                  @click="removeUser(user.id)"
                >
                  Usuń
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </app-user>
      </template>

      <AppEmptyState
        v-else
        :title="emptyStateTitle"
        :subtitle="emptyStateText"
      />
    </v-card-text>

    <v-card-actions v-if="editable">
      <v-btn
        depressed
        color="primary"
        @click="addTeamMember"
      >
        Dodaj osobę
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppEmptyState from '@/components/UI/AppEmptyState.vue';
import AppUser from '@/components/UI/AppUser.vue';

export default {
  components: {
    AppEmptyState,
    AppUser,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Oczekiewanie na dodanie członków zespołu projektowego.',
    },
  },

  computed: {
    usersCount() {
      return this.users.length;
    },

    usersCountSuffix() {
       return this.usersCount === 1 ? 'członek' : 'członków';
    },
    emptyStateTitle() {
      if (this.title.toLowerCase() === 'zespół zlecający') {
        return 'Brak zespołu zlecającego';
      }
      if (this.title.toLowerCase() === 'zespół decyzyjny') {
        return 'Brak zespołu decyzyjnego';
      }
      return 'Brak zespołu projektowego';
    },
  },

  methods: {
    removeUser(userId) {
      this.$emit('delete', userId);
    },

    addTeamMember() {
      this.$emit('add');
    },
  },
};
</script>

<style lang="scss" scoped>
.project-team-card {
  height: 100%;
  min-height: 370px;

  &__details {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.5px;
    font-weight: 400;
  }
  &__content {
    min-height: calc(370px - 60px);
    height: calc(100% - 116px);
    display: flex;
    flex-direction: column;
  }
}
</style>
